/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { StateCreator } from 'zustand';

const JOB_BANNERS_PAUSED_AT_KEY = 'jobBannersPausedAt';
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function getJobBannersPausedState(): boolean {
  try {
    const pausedAt = localStorage.getItem(JOB_BANNERS_PAUSED_AT_KEY);
    if (!pausedAt) return false;

    const pausedTimestamp = parseInt(pausedAt, 10);
    const now = Date.now();

    if (now - pausedTimestamp >= TWENTY_FOUR_HOURS_MS) {
      localStorage.removeItem(JOB_BANNERS_PAUSED_AT_KEY);
      return false;
    }

    return true;
  } catch {
    return false;
  }
}

export interface JobBannersSlice {
  jobBannersPaused: boolean;
  setJobBannersPaused: (paused: boolean) => void;
}

export const createJobBannersSlice: StateCreator<JobBannersSlice, [], [], JobBannersSlice> = (set) => ({
  jobBannersPaused: getJobBannersPausedState(),
  setJobBannersPaused: (paused: boolean) => {
    try {
      if (paused) {
        localStorage.setItem(JOB_BANNERS_PAUSED_AT_KEY, String(Date.now()));
      } else {
        localStorage.removeItem(JOB_BANNERS_PAUSED_AT_KEY);
      }
    } catch {
      // eslint-disable-next-line no-console
      console.warn('Failed to persist job banners paused state to localStorage');
    }

    set(() => ({
      jobBannersPaused: paused,
    }));
  },
});
